import z from 'zod/v4';
import { omit } from '../util/index.js';
import { SystemProcedure } from '../procedures/index.js';
export var PerformedByType;
(function (PerformedByType) {
    PerformedByType["Key"] = "KEY";
    PerformedByType["User"] = "USER";
    PerformedByType["Workflow"] = "WORKFLOW";
    PerformedByType["Trigger"] = "TRIGGER";
    PerformedByType["VoucherApplication"] = "VOUCHER_APPLICATION";
    PerformedByType["BulkAction"] = "BULK_ACTION";
    PerformedByType["Integration"] = "INTEGRATION";
    PerformedByType["Connect"] = "CONNECT";
    PerformedByType["Import"] = "IMPORT";
    PerformedByType["UpdateTypeOnCaseEnd"] = "UPDATE_TYPE_ON_CASE_END";
})(PerformedByType || (PerformedByType = {}));
export const toPublic = (performedBy) => {
    if (performedBy == null) {
        return performedBy;
    }
    switch (performedBy.type) {
        case PerformedByType.User:
        case PerformedByType.Key: {
            return omit(performedBy, ['ip', 'requestId']);
        }
        default:
            return performedBy;
    }
};
export const user = (id, options = {}) => {
    return {
        type: PerformedByType.User,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
export const key = (id, options = {}) => {
    return {
        type: PerformedByType.Key,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
export const workflow = (id) => {
    return {
        type: PerformedByType.Workflow,
        id,
    };
};
export const integration = (id) => {
    return {
        type: PerformedByType.Integration,
        id,
    };
};
export const trigger = (id, procedureId) => {
    return {
        type: PerformedByType.Trigger,
        id,
        procedureId,
    };
};
export const voucherApplication = (id) => {
    return {
        type: PerformedByType.VoucherApplication,
        id,
    };
};
export const bulkAction = (id) => {
    return {
        type: PerformedByType.BulkAction,
        id,
    };
};
export const connect = (id) => {
    return {
        type: PerformedByType.Connect,
        id,
    };
};
export const fromImport = (id) => {
    return {
        type: PerformedByType.Import,
        id,
    };
};
export const byUpdateTypeOnCaseEnd = (updateTypeId) => {
    return {
        type: PerformedByType.UpdateTypeOnCaseEnd,
        id: updateTypeId,
    };
};
export const PerformedBySchema = z.union([
    z.object({
        type: z.literal(PerformedByType.Key),
        id: z.uuid(),
        ip: z.ipv4().optional(),
        requestId: z.uuid().optional(),
    }),
    z.object({
        type: z.literal(PerformedByType.User),
        id: z.uuid(),
        ip: z.ipv4().optional(),
        requestId: z.uuid().optional(),
    }),
    z.object({
        type: z.literal(PerformedByType.Workflow),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Trigger),
        id: z.enum(SystemProcedure),
        procedureId: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.VoucherApplication),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.BulkAction),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Integration),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Connect),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Import),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.UpdateTypeOnCaseEnd),
        id: z.uuid(),
    }),
]);
//# sourceMappingURL=index.js.map